<script>
import moment from "moment";
import { deleteSubscriber, getS3Subscribers, deletedCustomer } from "@/api/subscribers";
import AddSubscriberDialog from "@/view/components/subscribers/AddSubscriberDialog.vue";
import UploadSubscribersModal from "@/view/components/subscribers/UploadSubscribersModal.vue";
import { money_format, dateFormat } from "@/utils";
import DataTableSection from "@/view/components/helper/datatable/datatableServerSide.vue";
import DataTableSingle from "@/view/components/helper/datatable/datatableSingleFetchS3.vue";
import swal from "sweetalert";
import papa from "papaparse";

export default {
  components: {
    AddSubscriberDialog,
    UploadSubscribersModal,
    DataTableSection,
    DataTableSingle
  },
  props: ["dspfunc"],
  data() {
    return {
      hide: false,
      loading1: false,
      s3items: [],
      copyOfS3items: [],
      nextItem: 1,
      companyName: '',
      useDatatableCSV: false,
      dataTableReady: false,
      usingBigdata: false,
      search: "",
      selected: [],
      dialogDelete: false,
      dialogMsg: "Are you sure you want to delete this selected items?",
      error: false,
      items: [],
      item: [],
      snackbar: false,
      text: "Loading guests...",
      timeout: 2000,
      loading: true,
      startSearchKeyLength: 3,
      upload: false,
      add: false,
      tableDataParam: {
        getters: 'getGuests',
        settersItem: 'setGuestItem',
        settersPage: 'setGuestPage',
        gettersPage: 'getGuestPage',
        // dispatchFunction: 'getLocationGuestsPaginated',
        dispatchFunction: this.dspfunc,
        headers: [
          {
            text: "Name",
            align: "start",
            sortable: false,
            value: "customer_name",
            width: "200px"
          },
          { text: "Revenue", value: "lifetime_revenue",width: "150px", sortable: false },
          { text: "Campaign Revenue", value: "campaign_revenue",width: "150px", sortable: false },

        ]
      },
      customRenderers: [
        {
          field: "customer_name",
        },
        {
          field: "created",
        },
        {
          field: "lifetime_revenue",
        },
        {
          field: "campaign_revenue",
        }
      ],
      tableDataParamCFG: {
        getters: 'getGuests',
        dispatchFunction: 'getGuestS3',
        setQuery: 'setGuestPageS3',
        getQuery: 'getGuestPageS3',
        queryValue: { pageFile: 1, totalRowsCount: 100, fileEndCount: 100 },
        headers: [
          {
            text: "Name",
            align: "left",
            sortable: false,
            value: "customer_name"
          },
          { text: "Email", value: "email", sortable: false },
          { text: "Revenue", value: "lifetime_revenue", sortable: false },
          { text: "First Transaction", value: "min_time", sortable: false }
        ]
      },
    };
  },
  computed: {
    searchTrigger() {
      return this.search;
    }
  },
  async mounted() {
    let accountSetting = await this.$store.getters["getAccountSettings"];
    console.log("Account Settings:",accountSetting)
    this.usingBigdata = accountSetting.company_details.company.using_bigdata    
    if (this.usingBigdata) {
      this.useDatatableCSV = true
      this.hide = true
    }
    this.dataTableReady = true
  },
  watch: {
    searchTrigger(q) {
      if (q.length >= this.startSearchKeyLength || q == "") {
        if (!this.useDatatableCSV) {
          let componentEvent = this.$refs.dataTableComponent
          componentEvent.requestAjaxTableData(q)
        } else {
          let componentEvent2 = this.$refs.dataTableComponentSecond
          componentEvent2.updateSearchField(q)
        }
      }
    }
  },
  methods: {
    moneyFormat(value) {
      return money_format(value);
    },
    dateFormat(value) {
      return moment(value).format("lll");
    },
    showAddDialog() {
      this.add = false;
      this.add = true;
      this.$store.commit("showAddDialog");
    },
    exportItems() {
      if (this.selected.length === 0) {
        swal('Error', "Please select at least one Guest");
      } else {

        let items = [];
        for (let i = 0; i < this.selected.length; i++) {
          let item = this.selected[i];
          if (!this.useDatatableCSV) { // export from api datatable
            items.push({
              id: item.id,
              name: item.customer_name,
              revenue: item.lifetime_revenue,
              campaign_revenue: item.campaign_revenue
            });
          } else {
            items.push({
              name: item.customer_name,
              email: item.email,
              revenue: item.lifetime_value,
              'transaction date': item.min_time
            });
          }

        }
        let csv = this.$papa.unparse(items);
        this.$papa.download(
          csv,
          `AllGuests-${moment().format("YYYY-MM-DD-HH-mm")}`
        );
      }
    },
    removeItems() {
      if (this.selected.length === 0) {
        this.error = true;
        this.dialogMsg = "Please select at least one item";
      } else {
        this.dialogMsg = "Are you sure you want to delete this selected items?";
        this.error = false;
      }
      this.dialogDelete = true;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    async removeItemsConfirm() {
      this.dialogDelete = false;
      for (let i = 0; i < this.selected.length; i++) {
        let item = this.selected[i];        
        let pk = item.customer_name + '_' + item.last_four_digits.toString().padStart(4, '0')
        let pos_id = item.pos_id
        let hash_id =  item.id
        try {
          let response = await deletedCustomer(pk, hash_id, pos_id);
          if ('success' in response){
            if(response['success']){
              this.$bvToast.toast(`Deleted ${item.customer_name}`, {
              title: "Subscriber",
              autoHideDelay: 3000,
              appendToast: false,
              variant: "info"
              });
            }          
          }        
        } catch (error) {
          console.log("error:",error)        
        }
      }
      this.selected = [];
      let componentEvent = this.$refs.dataTableComponent
      componentEvent.requestAjaxTableData()
      this.$router.push({ path: '/subscribers' })
    },
    showUpdateSubscriberModal(item) {
      localStorage.setItem("guest", "guest");
      localStorage.setItem("customerObj", JSON.stringify(item));
      this.$router.push(`/subscriber/profile/${item.pos_id}/${item.id}/a_1234?${item.pk_id}`);
    },
    formatDatetime(v) {
      return dateFormat(v);
    },
    syncSelectedItem(selectedCollection) {
      this.selected = selectedCollection
    }
  }
};
</script>

<template>
  <v-card flat>
    <v-row class="mb-5">
      <v-col cols="12" md="8">
        <v-btn v-if="!hide" class="mr-4" depressed tile @click="removeItems()">
          <v-icon left> mdi-delete</v-icon>
          Remove
        </v-btn>
        <v-btn class="mr-4" depressed tile @click="exportItems()">
          <v-icon left> mdi-file-export</v-icon>
          Export
        </v-btn>
        <v-btn class="mr-4" depressed tile @click="removeItems()">
          <v-icon left> mdi-delete </v-icon>
          Delete
        </v-btn>
      </v-col>
      <v-col cols="12" md="4">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <b-icon icon="search"></b-icon>
            </div>
          </div>
          <b-form-input v-model="search" placeholder="Search guest name"></b-form-input>
        </div>
      </v-col>
    </v-row>
    <data-table-single class="csv-datatable-customize" v-if="useDatatableCSV && dataTableReady" :tableData="this.tableDataParamCFG"
      :customRenderers="this.customRenderers" :isSelectEnabled="true" :selectKey="'customer_name'"
      :isSearch="this.loading" ref="dataTableComponentSecond" @datatableSelectedItem="syncSelectedItem">
      <template v-slot:customer_nameparams="{ item }">
        <v-btn text color="primary"
          @click="showUpdateSubscriberModal({ pk_id: item.customer_name + '_' + item.last_four_digits.toString().padStart(4, '0'), ...item })">
          {{ item.customer_name ? item.customer_name : "No Name" }}
        </v-btn>
      </template>

      <template v-slot:lifetime_revenueparams="{ item }">
        <span>{{ moneyFormat(item.lifetime_value) }}</span>
      </template>
      <template v-slot:campaign_revenueparams="{ item }">
        <span>{{ moneyFormat(0.0) }}</span>
      </template>
    </data-table-single>
    <data-table-section class="server-datatable-customize" v-if="!useDatatableCSV && dataTableReady" :tableData="this.tableDataParam"
      :customRenderers="this.customRenderers" :searchField="this.search" @datatableSelectedItem="syncSelectedItem"
      ref="dataTableComponent">
      <template v-slot:customer_nameparams="{ item }">
        <v-btn text color="primary" @click="showUpdateSubscriberModal(item)">
          {{ item.customer_name ? item.customer_name : "No Name" }}
        </v-btn>
      </template>

      <template v-slot:lifetime_revenueparams="{ item }">
        <span>{{ moneyFormat(item.lifetime_revenue) }}</span>
      </template>
      <template v-slot:campaign_revenueparams="{ item }">
        <span>{{ moneyFormat(item.campaign_revenue) }}</span>
      </template>
    </data-table-section>
    <v-dialog v-model="dialogDelete" max-width="510px">
      <v-card>
        <v-card-title class="headline">{{ dialogMsg }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="!error" color="blue darken-1" text @click="closeDelete">Cancel
          </v-btn>
          <v-btn v-if="!error" color="blue darken-1" text @click="removeItemsConfirm">OK
          </v-btn>

          <v-btn v-if="error" color="blue darken-1" text @click="closeDelete">Close
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <add-subscriber-dialog v-if="add"></add-subscriber-dialog>
    <upload-subscribers-modal v-if="upload"></upload-subscribers-modal>
  </v-card>
</template>